import { render, staticRenderFns } from "./ViewIcon.vue?vue&type=template&id=84050886"
import script from "./ViewIcon.vue?vue&type=script&lang=js"
export * from "./ViewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports